export async function registerCoach(apiInstance, coachData) {
  try {
    const response = await apiInstance.post(`/Coach/register`, coachData);
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function SearchCoachByName(apiInstance, name) {
  try {
    const response = await apiInstance.get(`/Coach/search?q=${name}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

//service for retrieving a coach
export async function getCoach(apiInstance, userId) {
  try {
    const response = await apiInstance.get(`/Coach/${userId}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

//viewing coach personal info
export async function getPersonalInfo(apiInstance) {
  try {
    const response = await apiInstance.get(`/Coach/profile/`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

//update coach personal info
export async function updatePersonalInfo(apiInstance, data) {
  try {
    const response = await apiInstance.put(`/Coach/profile/`, data);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function highschoolRegisterCoach(apiInstance, coachData) {
  try {
    const response = await apiInstance.post(`/highschool/register`, coachData);
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}
